import {
    ModuleWithProviders,
    NgModule,
} from '@angular/core';
import {
    PageCategory,
    PageScope,
    providePageMeta,
} from '@app/router';

@NgModule()
export class ProcessMetaModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: ProcessMetaModule,
            providers: [
                providePageMeta({
                    title: 'Processes',
                    translationKey: 'page_processes',
                    routerLink: '/processes',
                    sidebarSection: 'Automations',
                    svgIcon: 'uipath:processes',
                    permission: 'Processes.View',
                    type: 'Sidebar',
                    category: PageCategory.Tenant,
                    scope: PageScope.Folder,
                    priority: 0,
                }),
            ],
        };
    }
}
